import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class ArrowLink extends Component {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    if (this.props.onClick) {
      e.preventDefault();

      this.props.onClick(e);
    }
  }

  render() {
    var style = this.props.style;
    var size = this.props.size || 'medium';
    var disabled = this.props.disabled;
    const href = this.props.href;

    let className = cx({
      arrowLink: true,
      disabled: disabled,
      [`${style}`]: true,
      [`${size}`]: true,
    });

    return (
      <span className={classnames(className)}>
        <a href={href} onClick={this.handleOnClick}>
          {this.props.children}
        </a>
      </span>
    );
  }
}

ArrowLink.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    style: state.configuration.style,
  };
};

export default connect(mapStateToProps)(ArrowLink);
